import { FC } from 'react';

import { IconProps } from '.';

interface LogoIconProps extends IconProps {
  isWhite?: boolean;
}
export const LogoIcon: FC<LogoIconProps> = ({
  width = 99,
  height = 64,
  isWhite = false,
}) => {
  const secondaryColor = isWhite ? '#FFFFFF' : '#FFBA13';
  const primaryColor = isWhite ? '#FFFFFF' : '#003C78';
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 99 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="m49.49 2.905 29.25 29.09-29.25 29.092-29.25-29.091zM28.6 31.995 49.489 52.77l20.889-20.774L49.489 11.22z"
        fill={secondaryColor}
        stroke={secondaryColor}
        strokeWidth=".5"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M24.418 9.139 47.4 31.996 24.418 54.853 1.436 31.996zM9.798 31.996l14.62 14.54 14.62-14.54-14.62-14.541zM74.56 9.139l22.983 22.857L74.56 54.853 51.579 31.996zM59.94 31.996l14.62 14.54 14.621-14.54-14.62-14.541z"
        fill={primaryColor}
      />
      <path
        d="M70.378 31.996 49.489 11.22V2.905l29.25 29.09zm-41.777 0L49.489 52.77v8.317L20.24 31.996z"
        fill={secondaryColor}
      />
      <path
        d="M70.378 31.996 49.489 11.22V2.905l29.25 29.09zm-41.777 0L49.489 52.77v8.317L20.24 31.996z"
        stroke={secondaryColor}
        strokeWidth=".5"
        strokeLinejoin="round"
      />
    </svg>
  );
};
